import {assertNotNullable} from "@wix/devzai-utils-common";
import React, {useContext} from "react";

export interface BymoPageViewerApi {
    setDocumentScrollTop (scrollTop: number): void;
}

export const BymoPageViewerApiReactContext = React.createContext<BymoPageViewerApi | null>(null);

export function useBymoPageViewerApi(): BymoPageViewerApi {
    return assertNotNullable(useContext(BymoPageViewerApiReactContext))
}